import React from 'react';
import { Section } from '../ui/Section';
import { X, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function SystemComparison() {
  const problems = ['No sabés qué vender', 'No sabés cómo empezar', 'No sabés cómo conseguir clientes', 'No sabés cómo cerrar ventas', 'Perdés tiempo todos los días', 'Terminás frustrado'];
  return <Section className="bg-dark-900" data-id="element-263">
      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-264">
        {/* Left Side - Negative */}
        <div className="bg-dark-800 border border-red-900/30 p-8 md:p-12 rounded-3xl relative overflow-hidden" data-id="element-265">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/10 blur-[50px]" data-id="element-266" />

          <h3 className="text-3xl font-black text-red-500 mb-8 flex items-center gap-3" data-id="element-267">
            <X className="w-8 h-8" strokeWidth={3} data-id="element-268" />
            SIN SISTEMA
          </h3>

          <ul className="space-y-5" data-id="element-269">
            {problems.map((problem, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-gray-300" data-id="element-270">
                <span className="text-red-500 font-bold mt-1" data-id="element-271">❌</span>
                {problem}
              </li>)}
          </ul>
        </div>

        {/* Right Side - The Pivot */}
        <div className="flex flex-col justify-center space-y-12" data-id="element-272">
          <div className="space-y-6" data-id="element-273">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="flex items-center gap-4 text-2xl md:text-3xl font-bold text-gray-400" data-id="element-274">
              <ArrowRight className="text-gold-500 w-8 h-8" data-id="element-275" />
              No es falta de ganas
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex items-center gap-4 text-3xl md:text-4xl font-black text-white" data-id="element-276">
              <ArrowRight className="text-gold-500 w-10 h-10" data-id="element-277" />
              <span className="text-transparent bg-clip-text bg-gold-gradient" data-id="element-278">
                Es falta de un sistema
              </span>
            </motion.div>
          </div>

          <div className="bg-gold-500/10 border border-gold-500/30 p-8 rounded-2xl text-center" data-id="element-279">
            <h4 className="text-2xl md:text-3xl font-black text-white leading-tight" data-id="element-280">
              ⚠️ ¿Y SI ESTE FUERA EL MOMENTO QUE CAMBIA TODO?
            </h4>
          </div>
        </div>
      </div>
    </Section>;
}